import React, { useEffect, useState } from "react";

import { Navigate, useOutlet } from "react-router-dom";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import styled from "styled-components";
import ArrivalModal from "../components/modal/ArrivalModal";
import OrderCancelModal from "../components/modal/OrderCancelModal";
import ResponseModal from "../components/modal/ResponseModal";
import { NewOrderType, refreshOrderState } from "../recoil/socket";
import { ORDER_CANCLE_STATUS, ORDER_COM_DEL_STATUS } from "../recoil/type";

import LoadingModal from "../components/modal/LoadingModal";
import { requestNotificationPermission } from "../firebase";
import { qrAuthState, qrAuthType } from "../recoil/auth";
import { LoadingState } from "../recoil/loading";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";
import ErrorPage from "./ErrorPage";
import { arraivalAudio, cancelAudio } from "../utils/Audio";

let arrivalTimer: any;
let cancelTimer: any;

export const AllLayout = (oProps: any) => {
  const outlet = useOutlet();

  const [auth, setAuth] = useRecoilState<qrAuthType>(qrAuthState);

  const orderRefreshFlag = useRecoilValue<NewOrderType>(refreshOrderState);
  const resetRefreshFlag = useResetRecoilState(refreshOrderState);

  const [visibleArrival, setVisibleArrival] = useState<boolean>(false);
  const [visibleResponse, setVisibleResponse] = useState<boolean>(false);

  const [loadingVisible, setLoadingVisible] =
    useRecoilState<boolean>(LoadingState);
  const [visibleOrderCancel, setVisibleOrderCancel] = useState<boolean>(false);
  const [pickupName, setPickupName] = useState<string>("");
  const [pickupNameEn, setPickupNameEn] = useState<string>("");
  const [cancelDiscription, setCancelDiscription] = useState<string>("");

  const playArrivalAudio = () => {
    if (arraivalAudio) {
      arrivalTimer = setTimeout(() => {
        arraivalAudio.currentTime = 0;
        arraivalAudio.play();
      }, 5000);
    }
  };
  const playCancelAudio = () => {
    if (cancelAudio) {
      cancelTimer = setTimeout(() => {
        cancelAudio.currentTime = 0;
        cancelAudio.play();
      }, 5000);
    }
  };

  useEffect(() => {
    // if (process.env.REACT_APP_ENV === "PRD") {
    //   requestNotificationPermission();
    // }
    // if ('serviceWorker' in navigator) {
    //   console.log('serviceWorker');
    //   navigator.serviceWorker.addEventListener('message', receiveData);
    //   return () => {
    //     navigator.serviceWorker.removeEventListener('message', receiveData);
    //   };
    // }
  }, []);

  useEffect(() => {
    if (orderRefreshFlag.order_status === ORDER_COM_DEL_STATUS) {
      if (orderRefreshFlag.pickup_name) {
        setPickupName(orderRefreshFlag.pickup_name);
      }
      if (orderRefreshFlag.pickup_name_en) {
        setPickupNameEn(orderRefreshFlag.pickup_name_en);
      }
      setVisibleArrival(true);
    } else if (orderRefreshFlag.order_status === ORDER_CANCLE_STATUS) {
      if (orderRefreshFlag.cancel_description)
        setCancelDiscription(orderRefreshFlag.cancel_description);
      setVisibleOrderCancel(true);
    }
    resetRefreshFlag();
  }, [orderRefreshFlag]);

  useEffect(() => {
    if (arraivalAudio && visibleArrival) {
      arraivalAudio.currentTime = 0;
      arraivalAudio.play();
      arraivalAudio.addEventListener("ended", playArrivalAudio);
    } else clearTimeout(arrivalTimer);
    return () => {
      arraivalAudio.removeEventListener("ended", playArrivalAudio);
    };
  }, [visibleArrival]);

  useEffect(() => {
    if (cancelAudio && visibleOrderCancel) {
      cancelAudio.currentTime = 0;
      cancelAudio.play();
      cancelAudio.addEventListener("ended", playCancelAudio);
    } else clearTimeout(cancelTimer);
    return () => {
      cancelAudio.removeEventListener("ended", playCancelAudio);
    };
  }, [visibleOrderCancel]);

  useEffect(() => {
    if (auth.refresh_token !== "" && auth.expired_data !== null) {
      if (new Date(auth.expired_data).getTime() <= new Date().getTime()) {
        setAuth({
          refresh_token: "",
          user_token_id: 0,
          device_id: "",
          device_name: null,
          is_main: 1,
          client_user_id: 0,
          phone_number: "",
          user_id: 0, // hotel_id
          area_id: 0,
          room_id: 0,
          expired_data: null,
        });
        AsyncLocalStorage.removeItem("qrAuth");
      }
    }
  }, [outlet]);

  if (auth.refresh_token === "" || auth.expired_data === null) {
    return <ErrorPage />;
  }

  if (navigator.userAgent.includes("KAKAOTALK")) {
    window.location.assign("/");
  }

  return (
    <Style>
      <div className="screen">{outlet}</div>

      <ResponseModal
        isVisible={visibleResponse}
        setVisible={setVisibleResponse}
      />
      <ArrivalModal
        isVisible={visibleArrival}
        setVisible={setVisibleArrival}
        pickup_name={pickupName}
        pickup_name_en={pickupNameEn}
      />
      <OrderCancelModal
        isVisible={visibleOrderCancel}
        setVisible={setVisibleOrderCancel}
        cancel_description={cancelDiscription}
      />
      <LoadingModal
        isVisible={loadingVisible}
        setVisible={setLoadingVisible}
        cancel_description={cancelDiscription}
      />
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    width: 100%;
    height: 100%;
    min-height: auto;
  }
`;
